import { render } from "./PinCodeBatch.vue?vue&type=template&id=668d261a"
import script from "./PinCodeBatch.vue?vue&type=script&lang=js"
export * from "./PinCodeBatch.vue?vue&type=script&lang=js"
script.render = render

export default script